import lpApp from '../lp_app';
import { lpIdGetPure, lpIdGetCopy } from '../../logic/global_getter';
import { getMaa } from '../../redux/actions/load_contract';
import { checkUnInitializedSiblings } from '../../logic/utils/tree_operations';
import { lpGetOptionById } from '../../logic/re_index';
import ConditionsEvo from '../../logic/condition_evo';

/*
 * Project: LegalPlace assistant
 * File: src/app/ops/output.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

class LpOpsOutput {
  // get the children of an ID,
  static getChidlrenList(id) {
    return lpApp.references.getOption(lpIdGetPure(id)).children;
  }

  getOutput(optIds = [], out = [], isInRepeated = false) {
    const { store } = lpApp;
    optIds.map((idx) => {
      // if()
      // test existance
      // if(idx == 268)debugger;
      let cId = idx;
      let mId = 0;
      let amAMultiple = false;
      // check if the actual option is multiple
      if (typeof idx === 'string') {
        [cId, mId] = idx.split('_');
        amAMultiple = true;
      }

      // check the conditions
      if (lpApp.references.getOption(lpIdGetPure(idx)).meta.conditional
        && lpApp.references.getOption(lpIdGetPure(idx)).meta.compiledConditions
        && lpApp.references.getOption(lpIdGetPure(idx)).meta.compiledConditions.length > 0
      ) {
        let idxCopy = false;
        if (amAMultiple) {
          [, idxCopy] = idx.split('_');
        }

        if (!ConditionsEvo.getCondition(idx)) return;

        // if([262,266,278].includes(cId)) console.log(cId + ' : ' + cond.execute());
        // Checking condition
      }

      if (isInRepeated) {
        // if(idx == 32)debugger;
        // TODO: Test if there is something with children
        // let v = lpApp.indexes.options.getOption(idx);
        // if(v && v.value)
        // console.log(idx, cId)
        // if(lpIdGetPure(idx) == 266 || lpIdGetPure(idx) == 266)
        // console.log([lpApp.references.getOption(lpIdGetPure(idx)).meta.outputRender, idx]);
        // if(debug) console.log('>>>>> ' + idx)

        out.push([lpApp.references.getOption(cId).meta.outputRender, idx]);
        if (lpApp.references.getOption(cId).children.length > 0) {
          let { children } = lpApp.references.getOption(cId);
          if (amAMultiple) children = children.map(childrenIdx => `${childrenIdx}_${lpIdGetCopy(childrenIdx)}`);
          this.getOutput(children, out);
        }
        return;
      }
      // repeated case
      // TODO: add the possibility that it is true (in all cases)
      if (lpApp.references.getOption(lpIdGetPure(idx)).meta.type === 'repeated') {
        out.push([lpApp.references.getOption(lpIdGetPure(idx)).meta.outputRender, idx]);
        window.repeated = true;
        let repeatedChildren = LpOpsOutput.getChidlrenList(idx);
        // lpApp.references.getOption(lpIdGetPure(idx)).children;
        // get the repeated one
        const rAction = lpApp.references.getOption(lpIdGetPure(idx)).meta.repeatOption;
        const rList = lpApp.indexes.multiples.multiples
          ? lpApp.indexes.multiples.getMultiple(rAction)
          : false;
        if (repeatedChildren.length > 0) {
          if (lpIdGetPure(idx) === 574) this.getOutput(repeatedChildren, out, true, true);
          else this.getOutput(repeatedChildren, out, true);
          if (rList) {
            rList.map((i) => {
              repeatedChildren = repeatedChildren.map(jdx => `${lpIdGetPure(jdx)}_${i}`);
              // recurse
              if (lpIdGetPure(idx) === 574) this.getOutput(repeatedChildren, out, true, true);
              else this.getOutput(repeatedChildren, out, true);
            // do the same
            // console.log(repeatedChildren)
            }, this);
          }
        }
        window.repeated = false;
        return;
      }

      const pa = getMaa(idx);
      if (lpApp.references.getOption(cId).meta.type === 'radio'
        && checkUnInitializedSiblings(idx)
        && lpApp.references.getOption && pa && lpApp.references.getOption(pa)
        && idx === lpApp.references.getOption(pa).meta.default
      ) {
        out.push([lpApp.references.getOption(cId).meta.outputRender, idx]);

        // Checking children
        const referenceChildren = lpApp.references.getOption(cId).children;
        this.getOutput(referenceChildren, out, false);

        return;
      }
      // if(idx == 30)debugger;
      // the option is in the repeated case but it's a leaf
      // if(isInRepeated){
      //     // if(idx == 32)debugger;
      //     out.push([lpApp.references.getOption(cId).meta.outputRender, idx]);
      //     return
      // }
      // FIXME: initialization thing.
      // test if it's nothing in the whole system.
      // from here and till the end we just filter it
      let opt = lpGetOptionById(idx);
      // let opt = getOptionPass(idx)
      // if(cId == 218)debugger;
      if ((typeof opt === 'undefined')) {
        if (lpApp.references.getOption(cId).meta.type === 'radio') {
          // debugger;
          // here we can do the initialization from the default
          if (store.getState().loadedOvc && store.getState().loadedOvc.oF) {
            opt = { value: store.getState().loadedOvc.oF[idx] };
          } else opt = { value: false };
        } else if (lpApp.references.getOption(cId).meta.type === 'checkbox') {
          // debugger;
          // if(cId == 41)debugger;
          if (store.getState().loadedOvc && store.getState().loadedOvc.cF) {
            opt = { value: store.getState().loadedOvc.cF[idx] };
          } else opt = { value: false };
        } else {
          opt = { value: true };
        }
      }
      console.assert(typeof opt !== 'undefined', `This ${idx} is undefined`);
      if (typeof opt === 'number' || typeof opt === 'boolean') {
        //
        opt = { value: opt };
      }
      // test conditions [am smart XD] // the leaf
      // push it
      // initialization options that are not (displayed) but it's the default shit
      // number_of_all += 1;
      // console.log(idx, "ssss")
      if (opt.value
        || opt.value === 'NONE'
        || lpApp.references.getOption(cId).meta.type === 'hidden'
        || lpApp.references.getOption(cId).meta.type === 'static'
      ) {
        // if(idx == 32)debugger;
        // if
        // console.log(idx, "lll")
        out.push([lpApp.references.getOption(cId).meta.outputRender, idx]);
        // get children
        let { children } = lpApp.references.getOption(cId);
        if (children.length > 0) {
          if (amAMultiple) {
            children = children.map(jdx => `${jdx}_${mId}`);
          }
          // recurse
          // do the same
        }
        this.getOutput(children, out, false);
      }
      // test multiplie
      let multiples = lpApp.indexes.multiples.multiples
        ? lpApp.indexes.multiples.getMultiple(idx)
        : undefined;
      if (typeof multiples !== 'undefined') {
        // build multiple options list
        // debugger;
        multiples = multiples.map(jdx => `${idx}_${jdx}`);
        this.getOutput(multiples, out, false);
      }
      // recurse
    });
  }

  getOutputFroPreview(varId) {
    // extract the views,
    const vDeps = lpApp.indexes.var_to_view.getViewByVar(lpIdGetPure(varId));
    const copyUnique = lpIdGetCopy(varId);
    // Separate the thing
    const viewsIdx = lpApp.indexes.content.content.map(idx => idx[0]);
    const optsIdx = lpApp.indexes.content.content.map(idx => idx[1]);
    let indexes = [];
    if (typeof vDeps === 'undefined') return [];
    viewsIdx.map((idx, i) => vDeps.map(jdx => (jdx === idx ? indexes.push(i) : undefined)));
    // do some search in of the copy
    indexes = indexes.filter(idx => lpIdGetCopy(optsIdx[idx]) === copyUnique);
    const theIndex = indexes[0];
    const i1 = theIndex - 4 < 0 ? 0 : theIndex - 4;
    const i2 = theIndex + 4 > lpApp.indexes.content.content.length
      ? lpApp.indexes.content.content.length
      : theIndex + 4;
    return lpApp.indexes.content.content.slice(i1, i2);
  }
}

export default LpOpsOutput;



// WEBPACK FOOTER //
// ./src/app/ops/output.js